<template>

  <div class="content">
    <div id="countdown">
      <svg :width="size" :height="size">
        <circle fill="transparent" :stroke-width="stroke" stroke="#F5F6F7" :r="radius" :cx="circleOffset"
          :cy="circleOffset"></circle>
        <circle class="circle" fill="transparent" :stroke-width="stroke" stroke="#1890FF" :r="radius" :cx="circleOffset"
          :cy="circleOffset" :stroke-dasharray="circumference" :stroke-dashoffset="progress" stroke-linecap="round">
        </circle>
      </svg>
      <span>{{ countdown }}</span>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'Countdown',
  data: () => {
    return {
      size: 32,
      stroke: 2,
      percentage: 100,
      timer: null,
      seconds: 3
    }
  },
  computed: {
    radius() {
      return this.size / 2 - this.stroke / 2
    },
    circleOffset() {
      return this.size / 2
    },
    circumference() {
      return this.radius * 2 * Math.PI
    },
    progress() {
      return this.circumference - this.circumference * this.percentage / 100
    },
    countdown() {
      return Math.ceil(this.seconds * this.percentage / 100)
    }
  },
  methods: {
    animate() {
      this.timer = setInterval(() => {
        this.percentage = this.percentage - 100 / this.seconds / 100
        if (this.percentage <= 0) {
          clearInterval(this.timer)
        }
      }, 10)
    }
  },
  mounted() {
    this.animate()
  }
}
</script>

<style scoped lang="css">
.content {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#countdown {
  position: relative;
  background-color: #F5F6F7;
  border-radius: 100%;
  width: 32px;
  height: 32px;
}

#countdown span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  font-size: 24px;
  line-height: 24px;
  font-family: monospace;
  color: #1890FF;
  font-weight: 500;
}

.circle {
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}
</style>
